var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnexo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.501,
    height: 23.96,
    viewBox: "0 0 10.501 23.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#050606;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.5,4.5V18.75a5,5,0,0,1-.42,2,5.2,5.2,0,0,1-2.79,2.79,4.972,4.972,0,0,1-4,0A5.2,5.2,0,0,1,.42,20.79a5,5,0,0,1-.42-2v-15A3.52,3.52,0,0,1,.3,2.3a3.86,3.86,0,0,1,2-2A3.52,3.52,0,0,1,3.75,0,3.52,3.52,0,0,1,5.2.3a3.86,3.86,0,0,1,2,2,3.52,3.52,0,0,1,.3,1.45v15a2.16,2.16,0,0,1-.18.88,2,2,0,0,1-.48.71,2,2,0,0,1-.71.48,2.24,2.24,0,0,1-1.76,0,2,2,0,0,1-.71-.48,2,2,0,0,1-.48-.71A2.16,2.16,0,0,1,3,18.75V6H4.5V18.75a.75.75,0,0,0,1.5,0v-15a2.16,2.16,0,0,0-.18-.88,2,2,0,0,0-.48-.71,2,2,0,0,0-.71-.48,2.24,2.24,0,0,0-1.76,0,2,2,0,0,0-.71.48,2,2,0,0,0-.48.71,2.16,2.16,0,0,0-.18.88v15a3.52,3.52,0,0,0,.3,1.45,3.86,3.86,0,0,0,2,2,3.52,3.52,0,0,0,1.45.3,3.52,3.52,0,0,0,1.45-.3,3.86,3.86,0,0,0,2-2A3.52,3.52,0,0,0,9,18.75V4.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnexo);
export default __webpack_public_path__ + "static/media/anexo.fb771280.svg";
export { ForwardRef as ReactComponent };